<script lang="ts">
    import { PagedResult } from "$src/domain/core/PagedResult";
    import type { ISearchService } from "$src/domain/searches/ISearchService";
    import type { SearchResult } from "$src/domain/searches/SearchResult";
    import { ServiceTokens } from "$src/domain/ServiceTokens";
    import type { AuthContext } from "$src/infrastructure/accounts/AuthContext";
    import { ContextTokens } from "$src/presentation/contexts/ContextTokens";
    import LoadingIcon from "$src/presentation/defaults/loading-icon.svelte";
    import { getContext } from "svelte";
    import { t } from "svelte-i18n";
    import { container } from "tsyringe";
    import  * as Card from "$lib/components/ui/card";
    import * as Pagination from "$lib/components/ui/pagination"
    import { ScrollArea } from "$lib/components/ui/scroll-area/index.js";
    import { push } from 'svelte-spa-router';
    import ResultItem from "./result-item.svelte";
  import { getEndIndex, getStartIndex } from "$src/domain/core/utils/paged-result-utils";
  import MainTemplate from "$src/presentation/main/main-template.svelte";

    export let search: string = "";
    export let currentPage: number = 1

    let { activeGroupStore }  : AuthContext = getContext(ContextTokens.Auth);
    
    async function globalSearch(groupStoreId: number, search: string, pageNumber: number) : Promise<PagedResult<SearchResult>> {
        const searchService : ISearchService = container.resolve(ServiceTokens.SearchService);
        const result = await searchService.search(groupStoreId.toString(), search, pageNumber, 30);
	
        return result;
    }

    function setPage(page: number) {
        const queryParams = new URLSearchParams();
        queryParams.set('q', search);
        queryParams.set('page', page.toString());

        const searchUrl = `/gs/${$activeGroupStore?.groupStoreId}/search?${queryParams.toString()}`;

        push(searchUrl);
    }

</script>

<MainTemplate isEmbedded={false}>
{#if $activeGroupStore}
    {#await globalSearch($activeGroupStore.groupStoreId, search, currentPage)}
        <LoadingIcon />
    {:then resultPage} 
        <div class="max-w-2xl xl:ml-36">
            {#if resultPage.totalCount == 0 }
                { $t('page.search.results.noresult', { values: {query: search } })}
            {:else}
                <Card.Content class="flex flew-grow overflow-hidden max-w-2xl">
                    <ScrollArea orientation="vertical" class="h-full w-full">
                        <div class="flex flex-col gap-2 pt-0">
                            {#each resultPage.items as result}
                                <ResultItem resultItem={result} />
                            {/each}
                        </div>
                    </ScrollArea> 
                </Card.Content>
                <Card.Footer class="flex">
                    <Pagination.Root 
                        class="flex flex-row justify-end"
                        count={resultPage.totalCount} 
                        perPage={resultPage.pageSize} 
                        page={currentPage}
                        onPageChange={page => setPage(page)}
                        let:pages >
                        <Pagination.Content >
                            <div class="text-xs">
                                {`${getStartIndex(resultPage)}-${getEndIndex(resultPage)} de ${resultPage.totalCount}`}
                              </div>
                            <Pagination.Item>
                                <Pagination.PrevButton  />
                            </Pagination.Item>
                            <Pagination.Item>
                                <Pagination.NextButton/>
                            </Pagination.Item>
                            </Pagination.Content>
                    </Pagination.Root>
                </Card.Footer>
            {/if}
        </div>
    {:catch error}
        <p style="color: red">{error.message}</p>
    {/await}
{/if}
</MainTemplate>